import React from 'react';
import {TouchableOpacity, View} from 'react-native';
// import {images} from '../../../../../assets/icons';
import {CardInfo} from '../../../../../shared/components/cardInfo';
import {ContentWithRightImage} from '../../../../../shared/components/contentWithRightImage';
import Screen from '../../../../../shared/components/screen';
import {Table} from '../../../../../shared/components/table';
import {Column} from '../../../../../shared/components/table/model';
import {Text} from '../../../../../shared/components/text';
import {dateFormats} from '../../../../../shared/constants/date';
import {useStyles} from '../../../../../shared/hooks/styles';
import {ProvidingListApplication} from '../../../../../shared/models/api';
import {ProfileApplicationsStatus} from '../../../../../shared/models/profile/applications';
import {datePipe} from '../../../../../shared/pipes/date';
import {useTheme} from '../../../../../shared/theme';
import {stylePatterns} from '../../../../../shared/theme/patterns';
import {ApplicationsFilterDesktop} from '../applicationsFilter';
import {Button} from '../../../../../shared/components/button';
import {IStateProps} from './model';
import {ApplicationsFilterVisuallyImpaired} from '../applicationsFilterVisuallyImpaired';
import {capitalize} from '../../../../../shared/utils/text';

export default ({onPressItem, onLoadMore, applications, allShown, onApplyFilter, isVisuallyImpaired}: IStateProps) => {
  const _theme = useTheme();
  const styles = useStyles(({theme}) => ({
    h2: theme.fonts.h2,
    container: {
      marginHorizontal: 60,
      marginTop: 31,
      flex: 1,
      paddingBottom: 50,
    },
    wrap: {
      width: '100%',
      paddingTop: 40,
    },
    controls: {
      ...stylePatterns.flexCenterHorizontal,
      paddingTop: 20,
    },

    loadMoreButton: {
      width: 203,
    },
    colBodyMessageText: {
      ...theme.fonts.h6Light,
      color: theme.color.textColor,
    },
    colBodyMessageTextNotRead: {
      ...theme.fonts.h6,
      color: theme.color.textColor,
    },
    colBodyText: {
      ...theme.fonts.h5Light,
      color: theme.color.labelText,
    },
    colBodyTextNotRead: {
      // ...theme.fonts.action,
      // color: theme.color.textColor,
      ...theme.fonts.h5Light,
      color: theme.color.labelText,
    },
    icon: {
      height: 12,
      width: 12,
      color: theme.color.primaryColor,
    },
    colState: {
      flexBasis: 92,
      alignItems: 'center',
      justifyContent: 'center',
    },
    colText: {
      marginRight: 20,
      flexGrow: 1,
      flexShrink: 1,
    },
    colDate: {
      flexBasis: 140,
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 20,
    },
    colStatus: {
      flexBasis: 203,
    },
    colTime: {
      flexBasis: 92,
      alignItems: 'center',
      justifyContent: 'center',
    },
    titleWrapper: {
      marginBottom: 30,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'relative',
      zIndex: 2,
    },
    visuallyImpairedFilter: {
      marginBottom: 30,
    },
    contentStyle: {
      width: 862,
      minWidth: '65%',
    },
    cardVisuallyImpaired: {top: 54},
  }));

  const columns: Column<ProvidingListApplication>[] = [
    // {
    //   title: '',
    //   render: () => {
    //     const isRead = true; // application.isRead;
    //     return (
    //       <View style={styles.icon}>
    //         {isRead ? (
    //           <images.NotCheckRound width={styles.icon.width} height={styles.icon.height} color={styles.icon.color} />
    //         ) : (
    //           <images.CheckRound width={styles.icon.width} height={styles.icon.height} color={styles.icon.color} />
    //         )}
    //       </View>
    //     );
    //   },
    //   field: 'id',
    //   headStyles: {
    //     colHeadStyle: styles.colState,
    //   },
    //   styles: {
    //     colBodyStyle: styles.colState,
    //   },
    // },
    {
      title: 'Тип заявления',
      titleTestID: 'request-type-header-id',
      render: (application) => {
        const isRead = true; // application.isRead;
        return (
          <TouchableOpacity
            testID={`application-${application.id}-id`}
            onPress={() => onPressItem(application)}
            {...{dataSet: {class: 'link'}}}>
            <Text
              {...{dataSet: {class: 'applications-item-row__type'}}}
              style={isRead ? styles.colBodyMessageText : styles.colBodyMessageTextNotRead}>
              {capitalize(application.typeApplicationName)}
            </Text>
          </TouchableOpacity>
        );
      },
      field: 'typeApplicationName',
      headStyles: {
        colHeadStyle: styles.colText,
      },
      styles: {
        colBodyStyle: styles.colText,
      },
    },
    {
      title: 'Статус',
      titleTestID: 'request-status-header-id',
      render: (application) => {
        const isRead = true; // application.isRead;
        return (
          <Text
            style={[
              isRead ? styles.colBodyText : styles.colBodyTextNotRead,
              {
                color:
                  _theme.applications.statusColors[
                    (application.statusId as ProfileApplicationsStatus) || ProfileApplicationsStatus.accepted
                  ],
              },
            ]}>
            {application.statusName}
          </Text>
        );
      },
      field: 'statusName',
      headStyles: {
        colHeadStyle: styles.colStatus,
      },
      styles: {
        colBodyStyle: styles.colStatus,
      },
    },
    {
      title: 'Дата подачи',
      titleTestID: 'request-date-filig-header-id',
      render: (application) => {
        const isRead = true; // application.isRead;
        return (
          <Text style={isRead ? styles.colBodyText : styles.colBodyTextNotRead}>
            {datePipe(application.dateTimeFiling)}
          </Text>
        );
      },
      field: 'dateTimeFiling',
      headStyles: {
        colHeadStyle: styles.colDate,
      },
      styles: {
        colBodyStyle: styles.colDate,
      },
    },
    {
      title: 'Время',
      titleTestID: 'request-time-header-id',
      render: (application) => {
        const isRead = true; // application.isRead;
        return (
          <Text style={isRead ? styles.colBodyText : styles.colBodyTextNotRead}>
            {datePipe(application.dateTimeFiling, dateFormats.time)}
          </Text>
        );
      },
      field: 'dateTimeFiling',
      headStyles: {
        colHeadStyle: styles.colTime,
      },
      styles: {
        colBodyStyle: styles.colTime,
      },
    },
  ];

  return (
    <Screen>
      <View style={styles.container}>
        <ContentWithRightImage
          iconStyle={isVisuallyImpaired ? styles.cardVisuallyImpaired : {}}
          contentStyle={styles.contentStyle}
          icon={<CardInfo />}
          hideImage={true}>
          <View style={styles.wrap}>
            <View style={styles.titleWrapper}>
              <Text testID='show-requests-desktop-label-id' style={styles.h2}>
                Просмотр заявлений
              </Text>
              {!isVisuallyImpaired && !!applications?.length ? (
                <ApplicationsFilterDesktop onSubmit={onApplyFilter} />
              ) : null}
            </View>
            {isVisuallyImpaired ? (
              <View style={styles.visuallyImpairedFilter}>
                <ApplicationsFilterVisuallyImpaired onSubmit={onApplyFilter} />
              </View>
            ) : null}
            {!!applications && !applications.length ? (
              <Text testID='no-requests-desktop-label-id'>Заявления отсутствуют</Text>
            ) : null}
            {!applications || !!applications?.length ? <Table data={applications} columns={columns} /> : null}
            <View style={styles.controls}>
              {!allShown ? (
                <Button
                  id='profile-applications-more'
                  style={styles.loadMoreButton}
                  onPress={onLoadMore}
                  text='Показать еще'
                  type='secondary'
                />
              ) : null}
            </View>
          </View>
        </ContentWithRightImage>
      </View>
    </Screen>
  );
};
